<template>
  <v-container :style="styleProps">
    <v-card class="mt-5" flat>
      <v-card-title></v-card-title>
      <v-card-text>
        <v-row dense justify="space-between">
          <template v-for="item in fields">
            <v-col :key="item.pos" :md="item.cols" cols="auto" sm="12">
              <ent-input
                v-if="item.type === 'date'"
                :label="item.name"
                :config="item.format"
                v-model="item.data"
              ></ent-input>
              <ent-input
                v-if="item.type === 'string'"
                :label="item.name"
                :config="item.format"
                v-model="item.data"
              ></ent-input>
              <ent-select
                v-if="item.type === 'list' || item.type === 'multiselect'"
                :label="item.name"
                :config="item.format"
                :choices="item.choices"
                v-model="item.data"
              ></ent-select>
              <ent-switch
                v-if="item.type === 'status'"
                :label="item.name"
                :config="item.format"
                v-model="item.data"
              ></ent-switch>
              <ent-text-field
                v-if="item.type === 'textarea'"
                :label="item.name"
                :config="item.format"
                v-model="item.data"
              ></ent-text-field>
            </v-col>
          </template>
        </v-row>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script setup>
  import EntInput from "@/../../library/view/EntInput.vue";
  import EntSelect from "@/../../library/view/EntSelect.vue";
  import EntSwitch from "@/../../library/view/EntSwitch.vue";
  import EntTextField from "@/../../library/view/EntTextField.vue";
  import check from "@/../../library/helper/propertyCheck";
  import {
    schemaFetchandTranslate,
    schemaDataArray,
    canSave,
    prepareSavePayload,
  } from "@/../../cortex/src/compFunctions/useSchema.js";

  import { ref, computed, onMounted, watch } from "vue";

  // Define the props for this component
  const props = defineProps({
    args: { type: Object, required: false },
    formStyle: { type: String, required: false },
  });

  // Define the emits for this block
  const emit = defineEmits(["input", "update:saveok"]);

  // Define the style for this panel
  const styleProps = computed(() => {
    if (props.formStyle) return props.formStyle;
    return "width:800px; vertical-align:top; height:100vh";
  });

  // Translate the schema for the layout engine
  let fields = ref([]);

  // On Mounted
  onMounted(async () => {
    console.log(`****** Incoming Props: `, props.args);
    let schemaData = await schemaFetchandTranslate(props.args);
    fields.value = schemaData;
  });

  let record = ref([]);
  let saveEnable = ref(false);

  let saveCounter = ref(0);
  // Watch changed in the fields
  watch(
    fields,
    () => {
      record.value = schemaDataArray(fields.value);
      //console.log(`Record`, record.value)
      saveEnable.value = canSave(record.value, fields.value);
      //console.log(`Updated Record: `, record.value)
      //console.log(`Save Enable: `, saveEnable.value)
      if (saveEnable.value) {
        // console.log(`Emitting the save event`)
        let payload = prepareSavePayload(record.value, props.args);
        emit("update:saveok", saveCounter.value);
        emit("input", payload);
        saveEnable.value = !saveEnable.value;
        saveCounter.value++;
      }
    },
    { deep: true }
  );
</script>
